import { authHeader } from "../../_helpers/auth-header";
import { bmAPIs } from "../api-endpoints/BenchmarkingEndpoints";
import { tranStr } from "../../utils/translation";
import { AutoCloseModal } from "../../components/modal/Modal";

export async function updateBenchmarkComparisons(data) {
  // COST PLAN API
  const url = bmAPIs().update_benchmarks_comparisons;

  const payload = {
    ProjectId: data.projectId,
    BenchmarkId: data.benchmarkId,
    BenchmarkComparisonIds: data.benchmarkComparisonIds,
  };

  const config = {
    method: "POST",
    body: JSON.stringify(payload),
    headers: authHeader({ authJson: true, authForm: false, guestJson: false }),
  };

  let response = await fetch(url, config);

  return response.ok;
}

export async function saveBenchmarksSelection({
  selection,
  projectID,
  estimateID,
  CPs,
  setModal,
  setError,
}) {
  const selectedIDs = selection.map((s) => s.id);

  const benchmarkComparisonIds = [];
  selectedIDs.forEach((selectedId) => {
    benchmarkComparisonIds.push({
      BenchmarkId: selectedId,
      IsAnonymous: true,
    });
  });

  const data = {
    CPs: CPs,
    setModal: setModal,
    setError: setError,

    // Data
    projectId: projectID,
    benchmarkId: estimateID,
    benchmarkComparisonIds: benchmarkComparisonIds,
  };

  setError({
    text: tranStr("Saving..."),
    type: "feedback-success",
  });

  let isSaved = await updateBenchmarkComparisons(data);

  if (isSaved) {
    let cp = await data.CPs.get(data.projectId);
    data.CPs.set(cp);

    setError({
      text: tranStr("Saved Successfully"),
      type: "feedback-success",
    });

    AutoCloseModal(data.setModal);
  } else {
    setError({
      text: tranStr("Save Failed"),
      type: "feedback-error",
    });
  }
}

export async function saveBenchmarkComparisons(
  benchmarkId,
  linkedBenchmarksIds,
  comparisonId,
  isAnonymous
) {
  const benchmarkComparisonIds = [];
  linkedBenchmarksIds.forEach((linkedBenchmarkId) => {
    if (linkedBenchmarkId.benchmarkId === comparisonId) {
      // Update the state of the changed Benchmark Comparison
      benchmarkComparisonIds.push({
        BenchmarkId: linkedBenchmarkId.benchmarkId,
        IsAnonymous: isAnonymous,
      });
      // Simply Re-add the state of the other Benchmark Comparisons
    } else {
      benchmarkComparisonIds.push({
        BenchmarkId: linkedBenchmarkId.benchmarkId,
        IsAnonymous: linkedBenchmarkId.isAnonymous,
      });
    }
  });

  const data = {
    // Data
    benchmarkId: benchmarkId,
    benchmarkComparisonIds: benchmarkComparisonIds,
  };

  return await updateBenchmarkComparisons(data);
}
